import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="34038" id="willkommen-bei-wandelherz" className="relative w-full overflow-hidden bg-gradient-to-br from-[var(--color-background)] via-[var(--color-accent)]/40 to-[var(--color-background)] pt-24 pb-16 lg:pt-32 lg:pb-24 isolate">
      {}
      <div className="absolute top-0 right-0 -z-10 h-[500px] w-[500px] translate-x-1/3 -translate-y-1/4 rounded-full bg-[var(--color-primary)]/5 blur-[100px]" />
      <div className="absolute bottom-0 left-0 -z-10 h-[300px] w-[300px] -translate-x-1/3 translate-y-1/4 rounded-full bg-[var(--color-accent)]/20 blur-[80px]" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-16">
          {}
          <div ref={ref} className={`flex flex-col items-start space-y-8 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center rounded-full border border-[var(--color-primary)]/20 bg-[var(--color-primary)]/5 px-3 py-1 text-sm font-medium text-[var(--color-primary)]">
                <span className="mr-2 h-2 w-2 rounded-full bg-[var(--color-primary)] animate-pulse" />
                Begleitung & Retreats
              </div>
              <h2 className="text-4xl font-serif font-light tracking-tight text-[var(--color-primary)] sm:text-5xl lg:text-6xl xl:text-7xl">
                Willkommen bei <br />
                <span className="italic text-[var(--color-primary)]/80">
                  Wandelherz
                </span>{" "}
              </h2>
              <p className="max-w-xl font-sans text-lg text-[var(--color-muted-foreground)] sm:text-xl leading-relaxed">Finde zurück zu deiner inneren Mitte. Ich begleite dich achtsam auf deinem Weg der Transformation, Heilung und neuen Klarheit.</p>
            </div>

            <div className="flex flex-col w-full gap-4 sm:flex-row sm:w-auto">
              <Button asChild size="lg" className="bg-[var(--color-primary)] text-[var(--color-primary-foreground)] hover:bg-[var(--color-primary)]/90 shadow-lg shadow-[var(--color-primary)]/10 h-14 px-8 text-base rounded-md transition-all">
                <Link to="/RetreatsPage">
                  Retreats entdecken
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-[var(--color-primary)]/30 text-[var(--color-primary)] hover:bg-[var(--color-primary)]/5 h-14 px-8 text-base rounded-md transition-all">
                <Link to="/ContactPage">
                  <Phone className="mr-2 h-5 w-5" />
                  Kontakt aufnehmen
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-4 text-sm text-[var(--color-muted-foreground)]">
              
              
            </div>
          </div>

          {}
          <div className={`relative transition-all duration-1000 delay-200 ease-out ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-[var(--color-muted)] shadow-2xl lg:aspect-square">
              <img alt="Malerisches Lavendelfeld in der Schweiz bei Sonnenaufgang, weichgezeichnet" className="h-full w-full object-cover object-center transition-transform duration-1000 hover:scale-105" src="https://wandelherz.ch/wp-content/uploads/2026/10/8878dda5-e79e-47e7-b578-76f2098fbb45.jpg" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 rounded-xl border border-white/20 bg-white/40 p-4 shadow-lg backdrop-blur-md sm:bottom-8 sm:left-8 sm:right-auto sm:w-72">
                <div className="flex items-start gap-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--color-primary)]/20 text-[var(--color-primary)]">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                    </svg>
                  </div>
                  <div>
                    <p className="font-serif font-medium text-[var(--color-primary)]">
                      Achtsame Begleitung
                    </p>
                    <p className="text-xs text-[var(--color-muted-foreground)]">
                      Ich schaffe Raum für deine persönliche Entfaltung.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {}
            <div className="absolute -top-6 -right-6 -z-10 h-24 w-24 opacity-10">
               <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none">
                 <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                   <circle cx="2" cy="2" r="1.5" className="text-[var(--color-primary)]" fill="currentColor" />
                 </pattern>
                 <rect width="100" height="100" fill="url(#dots)" />
               </svg>
            </div>
          </div>
        </div>
      </div>
    </section>;
}